import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100",
  id: "FixedZoomMeetingContent"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "meetingSDKElement" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.appo && _ctx.appo.status == 10)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getSignature && _ctx.getSignature(...args)))
        }, "Join Meeting")
      ]))
    : _createCommentVNode("", true)
}